import { useId } from 'react';
import { cx } from '@/utils/cx';
import styles from '@/styles/components/Switch/style.scss';

interface SwitchProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  hint?: string;
  disabled?: boolean;
}

/** An on/off setting: the label (and hint) on the left, the switch on the right. A checkbox with role="switch". */
export function Switch({ label, checked, onChange, hint, disabled }: SwitchProps) {
  const id = useId();
  const hintId = hint ? `${id}-hint` : undefined;
  return (
    <label className={cx(styles.row, disabled && styles.disabled)} htmlFor={id}>
      <span className={styles.text}>
        <span className={styles.label}>{label}</span>
        {hint && (
          <span id={hintId} className={styles.hint}>
            {hint}
          </span>
        )}
      </span>
      <input
        id={id}
        type="checkbox"
        role="switch"
        className={styles.input}
        checked={checked}
        disabled={disabled}
        aria-describedby={hintId}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span className={cx(styles.track, checked && styles.on)} aria-hidden>
        <span className={styles.thumb} />
      </span>
    </label>
  );
}
